import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Seo from "@/components/Seo";
import Academia from "@/components/Academia";
import { PageLead } from "@/components/PageLead";
import { ContactForm } from "@/components/ContactForm";
import { useLang } from "@/i18n";
import { breadcrumbLd, courseListLd, organizationLd } from "@/lib/seo";

const Formacion = () => {
  const { lang, t } = useLang();

  return (
    <div className="bg-[#F5F1E8] overflow-x-hidden">
      <Seo
        title={t.seo.formacion.title}
        description={t.seo.formacion.description}
        path="/formacion"
        lang={lang}
        jsonLd={[
          organizationLd(),
          breadcrumbLd([
            { name: "Naguarà", path: "/" },
            { name: t.nav.academia, path: "/formacion" },
          ]),
          courseListLd(t.academia.courses),
        ]}
      />
      <Navbar />
      <div className="h-20 bg-[#422D28]" aria-hidden="true" />
      <main data-testid="page-formacion">
        <PageLead pageKey="formacion" title={t.seo.formacion.h1} />
        <Academia />
        <section className="bg-[#F5F1E8] pb-24 md:pb-32 px-6 md:px-12 lg:px-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-[#3B2523]">
              {t.academia.cta1}
            </h2>
            <div className="mt-8">
              <ContactForm kind="formacion" tone="light" testId="formacion-form" id="formulario" />
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Formacion;
